import api from "./api"

export function fnCreateBlock(nBoardId, cNameBlock) {
  const response = api.post(`/activity-block/${nBoardId}`, cNameBlock)
  return response
}

export function fnEditBlock(nBlockId, cNameBlock) {
  const response = api.patch(`/activity-block/${nBlockId}`, { cName: cNameBlock?.name })
  return response
}

export function fnMoveBlock(nBlockId, nNewBlockId) {
  const response = api.put(`/activity-block/${nBlockId}`, { new_board_nid: nNewBlockId })
  return response
}

export function fnListBlocks(nBoardId, cParams) {
  const response = api.get(
    `/activity-block/${nBoardId}${cParams ? `?${cParams}` : ""}&perPage=1000`,
  )
  return response
}
export function fnListBlocksPagination(oData) {
  const cPageRequest = oData.untilThisPage
    ? `&untilThisPage=${oData.untilThisPage}`
    : `page=${oData.page}`
  const cSearch = oData.search ? `&search=${oData.search}` : ""
  const response = api.get(
    `/activity-block/${oData.nBoardId}/list?${oData.page ? cPageRequest : ""}${cSearch}`,
  )
  return response
}
export function fnListBlockWithParams(nBoardId, cQuery, cParams) {
  const response = api.get(
    `/activity-block/${nBoardId}${cQuery ? `?${cQuery}` : ""}&perPage=1000`,
    { params: cParams },
  )
  return response
}

export function fnGetBlock(nBlockId) {
  const response = api.get(`/op-panel/block/${nBlockId}`)
  return response
}

export function fnDeleteBlocks(nBlockId, cPassword) {
  const response = api.delete(`/activity-block/${nBlockId}`, { data: cPassword })
  return response
}

export function fnChangeBlockOrderFields(nBlockId, aFields) {
  const response = api.patch(`activity-block-fields-order/${nBlockId}`, {
    fields: aFields,
  })
  return response
}

export function fnHiddenBlockFields(nBlockId, cIsFrom, aFieldsIds) {
  const params = new URLSearchParams()
  params.append("isFrom", cIsFrom)
  aFieldsIds.forEach((id) => {
    params.append("modelFieldIds[]", id)
  })

  const response = api.get(`/op-panel/block/${nBlockId}/hide-fields?${params}`)
  return response
}

export function fnCheckHasForm(nBlockId) {
  const response = api.get(`op-panel/block/${nBlockId}/checkCanDestroy`)
  return response
}

export function fnDuplicateBlock(nBlockId) {
  const response = api.post(`op-panel/block/${nBlockId}/duplicate`)
  return response
}
